import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  discounts: [],
  discount: {
    id: 0,
    idCongreso: 0,
    idCourse: 0,
    description: "",
    name: "",
    discountCode: "",
    percentage: false,
    discountPercentage: 0.0,
    nominal: false,
    discountNominal: 0.0,
    numberOfUses: 0,
    grupal: false,
    isValid: false,
  },
};

const discountSlice = createSlice({
  name: "discount",
  initialState,
  reducers: {
    restartState(state) {
      state.discount = {};
      state.discounts = [];
    },
    setDiscounts(state, actions) {
      state.discounts = actions.payload.discounts;
      state.discount = {};
    },
    setDiscount(state, actions) {
      state.discount = actions.payload.discount;
      state.discounts = [];
    },
    modifyPropertyValue(state, actions) {
      state.discount[actions.payload.id] = actions.payload.value;
    },
  },
});

export const discountActions = discountSlice.actions;
export default discountSlice;
